(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b_homepage_hero"]) return;
  try {
    
    $(document).on('shopify:section:select', function() {
    app.lazyload.init();
    }).on('shopify:section:load', function() {
    app.carousel.initHomepageLazy();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_accessories-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_allproducts-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_backpacks-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_gifts-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_lifestyle-accessories-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_lifestyle-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_lifestyle-lounge-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_lifestyle-office-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_m-apparel-base-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_m-apparel-bottoms-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_m-apparel-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_m-apparel-mid-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_sale-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_slippers-editions-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_slippers-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_slippers-soles-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_w-apparel-base-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_w-apparel-bottoms-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_w-apparel-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp_w-apparel-mid-items"]) return;
  try {
    
    $(document).on('shopify:section:load', function(){
    window.app.carousel.initCollectionCarousel();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.productShowcaseSliderBound) return;
    window.productShowcaseSliderBound = true;

    function initProductShowcaseSliders(scope) {
      if (typeof window.jQuery === 'undefined' || typeof jQuery.fn.owlCarousel !== 'function') {
        return false;
      }

      var $ = jQuery;
      var $root = $(scope || document);
      var $carousels = $root.find('.js-product-showcase-slider');

      $carousels.each(function() {
        var $el = $(this);
        var $section = $el.closest('.product-showcase-slider');
        var slideCount = $el.find('.product-showcase-slider__slide').length;

        if ($el.hasClass('owl-loaded')) {
          $el.trigger('destroy.owl.carousel');
        }

        if (slideCount < 2) {
          return;
        }

        $el.owlCarousel({
          items: 1,
          loop: true,
          nav: false,
          dots: false,
          margin: 0,
          mouseDrag: true,
          touchDrag: true,
          smartSpeed: 400
        });

        $section.find('.js-product-showcase-slider-prev').off('click.pss').on('click.pss', function() {
          $el.trigger('prev.owl.carousel');
        });

        $section.find('.js-product-showcase-slider-next').off('click.pss').on('click.pss', function() {
          $el.trigger('next.owl.carousel');
        });
      });

      return true;
    }

    function tryInit(scope) {
      if (initProductShowcaseSliders(scope)) return;
      setTimeout(function() { tryInit(scope); }, 50);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { tryInit(); });
    } else {
      tryInit();
    }

    document.addEventListener('shopify:section:load', function(event) {
      tryInit(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["title-and-copy-2"] && !Shopify.designMode) return;
  try {
    
  if (!window.titleCopyAccordionInited) {
  window.titleCopyAccordionInited = true;
  document.addEventListener('click', function(e) {
  var trigger = e.target.closest('[data-accordion-trigger]');
  if (!trigger) return;
  var expanded = trigger.getAttribute('aria-expanded') === 'true';
  var panelId = trigger.getAttribute('aria-controls');
  var panel = panelId && document.getElementById(panelId);
  trigger.setAttribute('aria-expanded', !expanded);
  if (panel) panel.hidden = expanded;
  });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["title-and-copy"] && !Shopify.designMode) return;
  try {
    
  if (!window.titleCopyAccordionInited) {
    window.titleCopyAccordionInited = true;
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-accordion-trigger]');
      if (!trigger) return;
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId && document.getElementById(panelId);
      trigger.setAttribute('aria-expanded', !expanded);
      if (panel) panel.hidden = expanded;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
